<template>
  <div>
    <Autocomplete
      :suggestions="suggestions"
      :disabled="pin === null"
      @selected="addToList"
    />
    <div class="invitee-list-container">
      <InviteeList :invitees="invitees" :editable="true" @removed="handleRemoved" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Autocomplete from './Autocomplete';
import InviteeList from './List';
import { getInvitees } from '../../../services/endpoints';

export default {
  components: { Autocomplete, InviteeList },

  mounted() {
    this.invitees = this.values;
  },

  data: () => ({
    suggestions: [],
    invitees: [],
  }),

  props: {
    values: Array,
  },

  computed: {
    ...mapState({
      pin: state => state.auth.pin,
    }),
  },

  methods: {
    addToList(user) {
      this.invitees.push(user);
      this.removeUserFromSuggestions(user);
    },

    removeUserFromSuggestions(user) {
      this.suggestions.splice(this.suggestions.indexOf(user), 1);
    },

    removeUsersFromSuggestions() {
      this.invitees.forEach((user) => {
        this.removeUserFromSuggestions(user);
      });
    },

    handleRemoved(key) {
      this.invitees.splice(key, 1);
    },
  },

  watch: {
    pin(value) {
      if (value === null) {
        this.suggestions = [];
      } else {
        getInvitees().then((response) => {
          this.suggestions = response.data.result;
          this.removeUsersFromSuggestions();
        });
      }
    },

    invitees(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .invitee-list-container {
    margin-top: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Booking/Invites/index.vue